// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".layer-legend-image[data-v-1f60df09]{max-width:100%;height:auto;display:block}", ""]);
// Exports
module.exports = exports;
